import {FC, useEffect, useState} from 'react';
import styles from './index.module.less';
import { PDFReader } from 'react-read-pdf';
import {
  ArrowRightOutlined,
  ArrowLeftOutlined, ExclamationCircleOutlined,
} from '@ant-design/icons';
import {Spin, notification} from "antd";

interface ISModalProps {
  url: string,
  open?: boolean
  pdfWidth?: number
  onClose?: () => void
}

const SModal: FC<ISModalProps> = (props: ISModalProps) => {
  const { url,pdfWidth = 700 } = props;
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    notification.config({
      placement: 'bottomRight',
      bottom: 100,
      duration: 3,
    })
  }, []);

  const getPdfInfo = (totalPage: any) => {
    setLoading(false);
    setTotalPage(totalPage);
  };

  const goNextPage = () => {
    if (currentPage === totalPage) {
      openNotification('已经是最后一页了');
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  const goPrePage = () => {
    if (currentPage === 1) {
      openNotification('已经是第一页了');
      return;
    }
    setCurrentPage(currentPage - 1);
  };

  const openNotification = (msg: string) => {
    notification.open({
      message: msg,
      icon: <ExclamationCircleOutlined style={{color: 'orange'}}/>
    });
  };

  return (
      <div className={styles.smodal} id={'erCode'}>
        <div className={styles.smodalWin}>
          <Spin spinning={loading}>
            <PDFReader width={pdfWidth} page={currentPage} onDocumentComplete={getPdfInfo} url={url} />
            {
                totalPage > 1 && (
                    <div className={styles.buttons}>
                      <div className={styles.jumpCheckButton} onClick={goPrePage}>
                        <ArrowLeftOutlined />
                        上一页
                      </div>
                      <div className={styles.jumpCheckButton} onClick={goNextPage}>
                        下一页
                        <ArrowRightOutlined />
                      </div>
                    </div>
                )
            }
          </Spin>
        </div>
      </div>
  );
};
export default SModal;